import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=4d8fee5c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d8fee5c')) {
      api.createRecord('4d8fee5c', component.options)
    } else {
      api.reload('4d8fee5c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=4d8fee5c&", function () {
      api.rerender('4d8fee5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KXMEmhPpqR6W/JS/comp/IncreaseNumber.vue"
export default component.exports